/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.CaravanTileView, {
    amount: {
        x: { align: "center" },
        y: { align: "bottom", dy: 140 }
    },

    title: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -25 }
    },

    button: {
        x: { align: "center" },
        y: { align: "bottom", dy: 50 }
    },

    rewardsBlock: {
        withBg: false,

        x: { align: "center" },
        y: { align: "bottom", dy: 140 },

        margin: 10,

        icon: {
            x: { align: "center", dx: -135 },
            y: { align: "center" }
        }
    },

    helpButton: {
        x: { align: "left", dx: 0 },
        y: { align: "top", dy: 5 }
    },

    badge: {
        x: { align: "right", dx: 33 },
        y: { align: "top", dy: 30 },
        scale: 1
    }
});
